import { render, staticRenderFns } from "./administrationSales.vue?vue&type=template&id=165f34b7&"
import script from "./administrationSales.vue?vue&type=script&lang=js&"
export * from "./administrationSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports